import React from 'react';
import { Box, Snackbar, Typography } from '@mui/material';
import { copyToastBoxSx } from '../css/revenueItems.styles';

const CopyLinkToast = ({ open, onClose }) => (
  <Snackbar
    open={open}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    autoHideDuration={2500}
    sx={{ top: { xs: 16, sm: 24 } }}
  >
    <Box sx={copyToastBoxSx}>
      <Box sx={{ width: 20, height: 20, flexShrink: 0 }}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" fill="#4caf50" />
          <path d="M5 10.5l3.5 3.5L15 7" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Box>
      <Typography sx={{ color: '#f3f4f7', fontFamily: 'Questrial, sans-serif', fontSize: '1rem' }}>
        Payment link copied!
      </Typography>
    </Box>
  </Snackbar>
);

export default CopyLinkToast;
